import { render, staticRenderFns } from "./editBusinessTableHis.vue?vue&type=template&id=ccbfff10"
import script from "./editBusinessTableHis.vue?vue&type=script&lang=js"
export * from "./editBusinessTableHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports